var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMockNordic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mock-Nordic-Sign-test-icon@1.5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mock-Nordic-Sign-test-icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.87
  }, /*#__PURE__*/React.createElement("g", {
    id: "MIS",
    transform: "translate(6.000000, 10.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "4.24666667 4.74666667 4.24 1.94666667 2.86666667 4.25333333 2.38 4.25333333 1.01333333 2.00666667 1.01333333 4.74666667 0 4.74666667 0 0.08 0.893333333 0.08 2.64 2.98 4.36 0.08 5.24666667 0.08 5.26 4.74666667"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "6.575 0.08 7.655 0.08 7.655 4.74666667 6.575 4.74666667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5033333,4.82666667 C10.1344444,4.82666667 9.77777778,4.77666667 9.43333333,4.67666667 C9.08888889,4.57666667 8.81222222,4.44666667 8.60333333,4.28666667 L8.97,3.47333333 C9.17,3.62 9.40777778,3.73777778 9.68333333,3.82666667 C9.95888889,3.91555556 10.2344444,3.96 10.51,3.96 C10.8166667,3.96 11.0433333,3.91444444 11.19,3.82333333 C11.3366667,3.73222222 11.41,3.61111111 11.41,3.46 C11.41,3.34888889 11.3666667,3.25666667 11.28,3.18333333 C11.1933333,3.11 11.0822222,3.05111111 10.9466667,3.00666667 C10.8111111,2.96222222 10.6277778,2.91333333 10.3966667,2.86 C10.0411111,2.77555556 9.75,2.69111111 9.52333333,2.60666667 C9.29666667,2.52222222 9.10222222,2.38666667 8.94,2.2 C8.77777778,2.01333333 8.69666667,1.76444444 8.69666667,1.45333333 C8.69666667,1.18222222 8.77,0.936666667 8.91666667,0.716666667 C9.06333333,0.496666667 9.28444444,0.322222222 9.58,0.193333333 C9.87555556,0.0644444444 10.2366667,0 10.6633333,0 C10.9611111,0 11.2522222,0.0355555556 11.5366667,0.106666667 C11.8211111,0.177777778 12.07,0.28 12.2833333,0.413333333 L11.95,1.23333333 C11.5188889,0.988888889 11.0877778,0.866666667 10.6566667,0.866666667 C10.3544444,0.866666667 10.1311111,0.915555556 9.98666667,1.01333333 C9.84222222,1.11111111 9.77,1.24 9.77,1.4 C9.77,1.56 9.85333333,1.67888889 10.02,1.75666667 C10.1866667,1.83444444 10.4411111,1.91111111 10.7833333,1.98666667 C11.1388889,2.07111111 11.43,2.15555556 11.6566667,2.24 C11.8833333,2.32444444 12.0777778,2.45777778 12.24,2.64 C12.4022222,2.82222222 12.4833333,3.06888889 12.4833333,3.38 C12.4833333,3.64666667 12.4088889,3.89 12.26,4.11 C12.1111111,4.33 11.8877778,4.50444444 11.59,4.63333333 C11.2922222,4.76222222 10.93,4.82666667 10.5033333,4.82666667 Z",
    id: "Path"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMockNordic);
export { ForwardRef as ReactComponent };